import React, { useMemo } from 'react'
import { View, TouchableHighlight } from 'react-native'
import MenuItemCard from './MenuItemCard'
import Colors from '../../../constants/Colors'
import { getBrandCardsLayout, getCategoryCardsLayout } from '../Helpers/functions'
import { useAppSelector } from '../../../state/hooks'
import { useOrganizationStyles } from '../../../hooks/useOrganizationStyles'
import { isIOS, isOldIOS } from '../../../helpers/deviceDetections'
import { useBreakpoints } from '../../../components/DesignSystem'
import { useFirebaseAnalyticsContext } from '../../../context/FirebaseAnalyticsContext'

const RowItems = ({
	name,
	rowItems,
	searchResults = false,
	storeOpen,
	navigation,
	rId = null,
	rName = null,
	isSnoozedState = null,
	categoryName = null,
	isBrandMenu = false,
	singleBrandEnabled = false,
	categoryIndex,
	onItemPress,
	showImages,
}) => {
	const { restaurants } = useAppSelector(state => state.data)
	const { appBackground } = useOrganizationStyles()
	const { logSelectItemAnalytics } = useFirebaseAnalyticsContext()
	const card = useMemo(
		() =>
			isBrandMenu
				? getBrandCardsLayout(singleBrandEnabled, searchResults)
				: getCategoryCardsLayout(),
		[isBrandMenu, singleBrandEnabled, searchResults]
	)

	const isItemAvailable = item => {
		if (Object.prototype.hasOwnProperty.call(item, 'isOpen')) {
			return item.isOpen
		}
		return storeOpen
	}

	return (
		<View
			style={{
				flexDirection: 'row',
				flexWrap: 'wrap',
				justifyContent: 'space-between',
				marginBottom: searchResults ? 0 : isBrandMenu ? '4%' : '8%',
			}}
		>
			{rowItems.map((token, index) => (
				<View key={token.id + (isBrandMenu ? '_branditem_' : '_ctgitem_') + index}>
					{token.invisible || (!isItemAvailable(token) && !isBrandMenu) ? (
						<View style={{ width: card.width }}>
							<View style={{ width: '100%', height: 0 }} />
						</View>
					) : (
						<TouchableHighlight
							onPressIn={onItemPress}
							style={isBrandMenu ? { marginBottom: '15%' } : {}}
							key={token.id + index}
							underlayColor={appBackground}
							onPress={() => {
								logSelectItemAnalytics(
									isBrandMenu ? rId : 'category_' + categoryName,
									isBrandMenu ? rName : categoryName,
									token.price,
									{
										item_id: token.id,
										item_name: token.name,
										item_category: name,
									}
								)

								const restaurant = restaurants.find(r => r.id === token.rId)
								const slug = categoryName ? `category_${categoryName}` : restaurant.slug
								const sharedArgs = {
									token: token.id,
									editing: null,
									isOpen: isItemAvailable(token),
									categoryIndex,
									menuItemCategory: name,
									menuId: isBrandMenu ? rId : 'category_' + categoryName,
									...(isBrandMenu && { isRestaurantSnoozed: isSnoozedState }),
									category: !isBrandMenu,
								}

								const navigator = isOldIOS() ? navigation.replace : navigation.navigate
								if (!slug) {
									navigator('Item', sharedArgs)
								} else {
									navigator('HomeStack', {
										screen: 'MenuItemBySlug',
										params: {
											menu: slug,
											categoryIndex,
											slug: token.slug,
											...sharedArgs,
										},
									})
								}
							}}
						>
							<View
								style={{
									width: card.width,
									marginBottom: '15%',
								}}
							>
								<MenuItemCard
									storeOpen={isItemAvailable(token)}
									key={token.id + index}
									id={token.id}
									name={token.name}
									desc={token.desc}
									price={token.price}
									imageUri={showImages ? token.image : ''}
									promoPrice={token.promoPrice}
									width={card.width}
									variationMinPrice={token.variationMinPrice}
									variationMaxPrice={token.variationMaxPrice}
								/>
							</View>
						</TouchableHighlight>
					)}
				</View>
			))}
		</View>
	)
}

export default RowItems
